import React, { useState } from 'react';
import { Translation, useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

import { showToast } from 'stores/ToastStore';
import CargomaticModal from 'components/v2/modal';
import CargomaticInput from 'components/v2/input';

export default function MarketShipperRateModel({
  showModal,
  setShowActionModel,
  shipment,
  onSave,
  curRate,
  curFreeDays,
}) {
  const { t } = useTranslation();

  const [rate, setRate] = useState(curRate || 0);
  const [freeDays, setFreeDays] = useState(curFreeDays || 0);

  const handleSave = () => {
    onSave(rate, freeDays, shipment);
  };

  const renderModalBody = () => {
    return (
      (<div data-testid="div-4ab355de" className="pl-4 pr-4">
        <p data-testid="p-6a062d86" className="text-sm text-gray-500">{t('NOT_SHIPPER_MARKET_RATE')}</p>
        <p data-testid="p-790e02b9" className="text-sm text-gray-500 mb-4">
          {t('PROVIDE_RATE_AND_FREE_DAYS')}
        </p>
        <div data-testid="div-874b3c11" className="flex justify-between space-x-2">
          <div data-testid="div-26e9c0b0" className="w-50">
            <CargomaticInput
              dataTestId="CargomaticInput-4f236893"
              type="number"
              label={t('RATE')}
              placeholder={t('RATE')}
              value={rate}
              onChange={(value) => setRate(value ? Number(value) : null)} />
          </div>
          <div data-testid="div-a94dd25e" className="w-50">
            <CargomaticInput
              dataTestId="CargomaticInput-3c7a2afc"
              type="number"
              label={t('FREE_DAYS')}
              placeholder={t('FREE_DAYS')}
              value={freeDays}
              onChange={(value) => setFreeDays(value ? Number(value) : null)} />
          </div>
        </div>
      </div>)
    );
  };

  const renderFooter = () => {
    return (
      (<div data-testid="div-137620a5" className="flex justify-end mr-4 mb-2">
        <button
          data-testid="button-a8bec876"
          className="button button-secondary"
          onClick={() => setShowActionModel(false)}>
          <Translation>{(t) => t('CANCEL')}</Translation>
        </button>
        <button
          data-testid="button-70beb793"
          className="block button button-green"
          onClick={handleSave}
          disabled={!(rate > 0 && freeDays >= 0 && freeDays < 100)}>
          <Translation>{(t) => titleize(t('SAVE'))}</Translation>
        </button>
      </div>)
    );
  };

  return (
    (<CargomaticModal
      dataTestId="CargomaticModal-27a4d6be"
      dialogClassName="w-full md:w-1/4"
      title={
        <h3 data-testid="h3-bacd71e1" className="font-medium pl-4 mt-3 mb-1">
          {t('OVERRIDE_SHIPMENT_RATE')}
        </h3>
      }
      style={{ top: '20%' }}
      show={showModal}
      onHide={() => setShowActionModel(false)}
      backdrop="static"
      body={renderModalBody()}
      footer={renderFooter()}
      location="middle" />)
  );
}
